import { put, call } from 'redux-saga/effects';
import 'whatwg-fetch';

const userAgent = 'pinchos/1.0 pinchos/1.0 hammer/1 hammer/1';
const acceptLanguage = 'en, sv';
const acceptCharset = 'utf-8';
const contentTypeJson = 'application/json; charset=utf-8';

export function* callApiAsync(targetFn, onSuccessFn, onErrorFn, args = []) {
  const apiCall = yield call(() => targetFn(...args));
  if (apiCall && apiCall.success) {
    yield put(onSuccessFn(apiCall));
  } else {
    yield put(onErrorFn(apiCall));
  }
}

export function callApi(url, method, headers, body) {
  const content = { method, headers };
  if (body) {
    content.body = JSON.stringify(body);
  }
  return fetch(url, { ...content, credentials: 'include' })
    .then((res) => {
      const result = { success: res.ok };
      if (responseHasJsonBody(res)) {
        return res.json().then((json) => {
          result.json = json;
          return result;
        });
      }
      return result;
    })
    .catch((error) => error);
}

function responseHasJsonBody(response) {
  const contentType = response.headers.get('Content-Type');
  return contentType ? contentType.includes('json') : false;
}


export function getApi(url) {
  const headers = new Headers();
  headers.append('Accept', contentTypeJson);
  headers.append('Accept-Charset', acceptCharset);
  headers.append('Accept-Language', acceptLanguage);
  headers.append('X-User-Agent', userAgent);
  return callApi(url, 'GET', headers);
}

export function putApi(url, body) {
  const headers = new Headers();
  headers.append('Content-Type', contentTypeJson);
  headers.append('Accept', contentTypeJson);
  headers.append('Accept-Charset', acceptCharset);
  headers.append('Accept-Language', acceptLanguage);
  headers.append('X-User-Agent', userAgent);
  return callApi(url, 'PUT', headers, body);
}

export function postApi(url, body) {
  const headers = new Headers();
  headers.append('Content-Type', contentTypeJson);
  headers.append('Accept', contentTypeJson);
  headers.append('Accept-Charset', acceptCharset);
  headers.append('Accept-Language', acceptLanguage);
  headers.append('X-User-Agent', userAgent);
  return callApi(url, 'POST', headers, body);
}

export function deleteApi(url) {
  const headers = new Headers();
  headers.append('Accept', contentTypeJson);
  headers.append('Accept-Charset', acceptCharset);
  headers.append('Accept-Language', acceptLanguage);
  headers.append('X-User-Agent', userAgent);
  return callApi(url, 'DELETE', headers);
}
